export default "__VITE_ASSET__CKPB_1vw__"